import { External } from "components/icons/generated";
import { AI_SURVEY_LINK } from "constants/url";
import Feedback from "ds/components/Feedback";
import Link from "ds/components/Link";
import { AnalyticsPageInfraAssistant } from "hooks/useAnalytics/pages/infraAssistant";
import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { AccountContext } from "views/AccountWrapper";

import styles from "./styles.module.css";

const ChatSurveyBanner = () => {
  const { aiSurvey } = useTypedFlags();
  const { spaceliftIntelligenceEnabled } = useTypedContext(AccountContext);

  if (!aiSurvey || !spaceliftIntelligenceEnabled) {
    return null;
  }

  return (
    <Feedback
      variant="info"
      type="banner"
      storageKey="chat-ai-survey"
      className={styles.surveyBanner}
    >
      Help us improve Spacelift and{" "}
      <Link
        href={AI_SURVEY_LINK}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={External}
        size="inherit"
        inheritFont
        analyticsPage={AnalyticsPageInfraAssistant.InfraAssistant}
        analyticsTitle="Infra Assistant - AI Survey Clicked"
      >
        take the survey
      </Link>
      .
    </Feedback>
  );
};

export default ChatSurveyBanner;
